import {isToFile} from './helpers';

function reloadCaptcha($imgCaptcha, isNewCore) {
    if (isNewCore) {
        const base = getVikonCoreScriptUrl();
        $imgCaptcha.attr('src', `${base}/captcha.php?sid=${Math.random()}`);
    } else {
        $imgCaptcha.attr('src', `/sveden/update/captcha/captcha.php?sid=${Math.random()}`);
    }
}

export function initHotLineIfNeed($container) {
    const $btnFeedbackSend = $container.find('.feedback-send');
    if ($btnFeedbackSend.length) {
        const $imgCaptcha = $container.find('.captcha');
        const $nameField = $container.find('[name="name"]');
        const $emailField = $container.find('[name="email"]');
        const $subjectField = $container.find('[name="subject"]');
        const $messageField = $container.find('[name="message"]');
        const $captchaField = $container.find('[name="captcha"]');
        const $isNewCore = Boolean(Number($_vikon('#isNewCore').val()));

        if (isToFile()) {
            reloadCaptcha($imgCaptcha, $isNewCore);
            $imgCaptcha.on('click', () => {
                reloadCaptcha($imgCaptcha, $isNewCore);
            });
        }

        $container.on('click', '.feedback-send', () => {
            const $feedbackStatus = $container.find('.feedback-status');
            const feedbackUrl = $isNewCore
                ? `${getVikonCoreScriptUrl()}/feedback_abitur.php`
                : `/sveden/update/feedback.php`;
            if (isToFile()) {
                const form = $container.find('.feedback-form').serialize();
                $nameField.parent().removeClass('has-error');
                $emailField.parent().removeClass('has-error');
                $subjectField.parent().removeClass('has-error');
                $messageField.parent().removeClass('has-error');
                $captchaField.parent().removeClass('has-error');
                $feedbackStatus.removeClass('bg-danger bg-success')
                    .html('<ul></ul>')
                    .addClass('hide');
                $_vikon.ajax({
                    type: 'post',
                    url: feedbackUrl,
                    data: form,
                    dataType: 'json',
                    success(res) {
                        if (res.success) {
                            $feedbackStatus.html('Сообщение отправлено')
                                .addClass('bg-success')
                                .removeClass('hide');
                            $nameField.val('');
                            $emailField.val('');
                            $subjectField.val('');
                            $messageField.val('');
                            $captchaField.val('');
                            reloadCaptcha($imgCaptcha, $isNewCore);
                        } else {
                            if (res.message) {
                                $feedbackStatus.html(`Сообщение не отправлено. ${res.message}`)
                                    .addClass('bg-danger')
                                    .removeClass('hide');
                            }
                            res.errorID.forEach((item, i, arr) => {
                                $container.find(`[name="${item}"]`).parent().addClass('has-error');
                            });
                            res.messages.forEach((item, i, arr) => {
                                $feedbackStatus.children('ul:first').append(`<li>${item}</li>`);
                                $feedbackStatus.addClass('bg-danger');
                                $feedbackStatus.removeClass('hide');
                            });
                            reloadCaptcha($imgCaptcha, $isNewCore);
                            $captchaField.val('');
                        }
                    },
                });
            } else {
                $feedbackStatus.html('Недоступно в просмотре информации')
                    .addClass('bg-danger')
                    .removeClass('hide');
            }
        });
    }
}

function getVikonCoreScriptUrl() {
    const corePath = $_vikon('meta[name="vikon_core_path"]').attr('content');
    // Если meta не найдена или пустая — используем дефолт
    if (!corePath) {
        return '/vikon_core/scripts';
    }

    return `${corePath}/scripts`;
}
